module.exports = "/_next/static/images/42c69da4e9d7d824a2fb3ce18dac0efb-title-icon.svg";